import React, { useEffect, useState } from "react";
import { Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Swal from "sweetalert2";

import request from "../../../../Helpers/API";

// Solo permite marcar la visita como realizada — no es un cambio de estatus libre
const ESTATUS_REALIZADA = "R";

// Modal para marcar una visita como realizada — conectado a VisitasCRM/GuardarEstatusVisita
export const VisitasModalEstatus = ({ open, visita, onClose }) => {
  const [comentario, setComentario] = useState("");
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    if (open) setComentario("");
  }, [open]);

  if (!visita) return null;

  const validar = () => {
    if (!comentario.trim()) { Swal.fire("VISITAS", "Captura un comentario sobre la visita realizada", "warning"); return false; }
    return true;
  };

  const handleGuardar = () => {
    if (!validar()) return;

    const body = {
      idvisita: visita.id_visita,
      estatus: ESTATUS_REALIZADA,
      comentario,
      createuser: 0,
    };

    setGuardando(true);
    request
      .post("VisitasCRM/GuardarEstatusVisita", body)
      .then(async () => {
        setGuardando(false);
        await Swal.fire("VISITAS", "Visita marcada como realizada", "success");
        onClose(true);
      })
      .catch((error) => {
        setGuardando(false);
        Swal.fire("VISITAS", JSON.stringify(error), "error");
      });
  };

  return (
    <Modal open={open} onClose={() => onClose(false)}>
      <div className="crm-modal-card">
        <button type="button" className="crm-modal-cerrar" onClick={() => onClose(false)}>
          <CloseIcon fontSize="small" />
        </button>

        <h3 className="crm-modal-titulo">Marcar visita como realizada · {visita.razon_social}</h3>

        <div className="crm-modal-body">
          <div className="crm-field">
            <label>Comentario</label>
            <textarea
              className="crm-field-editable crm-modal-textarea"
              rows={4}
              placeholder="Detalle de lo tratado en la visita..."
              value={comentario}
              onChange={(e) => setComentario(e.target.value)}
            />
          </div>
        </div>

        <div className="crm-modal-buttons">
          <button type="button" className="btn-secundario-outline" onClick={() => onClose(false)}>Cancelar</button>
          <button type="button" className="btn-primario-solido" onClick={handleGuardar} disabled={guardando}>Marcar como realizada</button>
        </div>
      </div>
    </Modal>
  );
};
